import { render, staticRenderFns } from "./CustomerLookup.view.vue?vue&type=template&id=fc62a9f0&scoped=true"
import script from "./CustomerLookup.view.vue?vue&type=script&lang=ts"
export * from "./CustomerLookup.view.vue?vue&type=script&lang=ts"
import style0 from "./CustomerLookup.view.vue?vue&type=style&index=0&id=fc62a9f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc62a9f0",
  null
  
)

export default component.exports